import { randWord, randNumber, randSequence } from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { MockCalculator } from './calculator.mock';

import { Container } from '../base';

export class MockContainer extends Container {
   constructor( itemized = false ) {
      super({
         type: randWord(),
      });

      if ( optional() ) { this.number = randSequence(); }
      if ( optional() ) { this.sealNumber = randWord(); }
      if ( itemized || optional() ) {
         this.items = Array.from({ length: randNumber({ max: 10 })}, _ => new MockCalculator() );
      }
   }
}
